"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledThumbnailImage = exports.StyledThumbnailIcon = exports.StyledSpinner = exports.StyledThumbnail = exports.StyledFileRow = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Tokens = __importStar(require("../../styles/tokens"));
const Flex_1 = require("../Layout/Flexbox/Flex");
const Spinner_1 = require("../Spinner/Spinner");
const Attachment_types_1 = require("./Attachment.types");
exports.StyledFileRow = (0, styled_components_1.default)(Flex_1.Flex).attrs({
    justifyContent: "space-between",
    alignItems: "center",
}) `
    border: ${Tokens.BORDERS.normal.silver};
    border-radius: ${Tokens.BORDERS.radius};
    background-color: ${Tokens.COLOURS.greyscale.white};
    padding: ${Tokens.SIZES[1]} ${Tokens.SIZES[1.5]};
    max-width: 40rem;
    width: 100%;
`;
exports.StyledThumbnail = (0, styled_components_1.css) `
    height: ${Tokens.SIZES[6]};
    width: ${Tokens.SIZES[6]};
    border-radius: ${Tokens.BORDERS.radius};
    margin-right: ${Tokens.SIZES[1]};
`;
// Fixing these to match the icon sizes in other cases which are all 40px
exports.StyledSpinner = (0, styled_components_1.default)(Spinner_1.Spinner) `
    > * {
        width: 40px;
        height: 40px;
    }
`;
exports.StyledThumbnailIcon = (0, styled_components_1.default)(Flex_1.Flex).attrs({
    alignItems: "center",
}) `
    ${exports.StyledThumbnail}
    background-color: ${(props) => {
    switch (props.status) {
        case Attachment_types_1.Status.Error:
            return Tokens.COLOURS.primary.red[10];
        case Attachment_types_1.Status.Loading:
            return Tokens.COLOURS.primary.blue[10];
        default:
            return Tokens.COLOURS.greyscale.cloud;
    }
}};
    padding-left: ${Tokens.SIZES[0.5]};
`;
exports.StyledThumbnailImage = styled_components_1.default.img `
    ${exports.StyledThumbnail}
    display: inline-block;
`;
//# sourceMappingURL=Attachment.styles.js.map